<template>
  <div class="hp-base-panel-wrp">
    <div class="desc-panel hp-base-panel">
      <template v-if="parsedQualifications">
        <div class="hp-title">
          <div>
            <em class="left">资质证书</em>
          </div>
          <div class="ic-year" v-if="tagList" @click="onTagClick">
            <span class="ic-year-text">{{ tagList.title }}</span>
          </div>
        </div>
        <div class="normal-text" v-html="parsedQualifications"></div>
      </template>

      <template v-if="consultServiceInfo.consult_style">
        <div class="hp-title">
          <em class="left">咨询风格</em>
        </div>
        <div
          class="normal-text"
          v-html="consultServiceInfo.consult_style"
        ></div>
      </template>

      <template v-if="trainings.length">
        <div class="hp-title">
          <em class="left">培训经历</em>
        </div>
        <ul class="training-desc">
          <li
            v-for="(v, index) in slicedTrainings"
            :key="index"
            class="training"
          >
            <div class="tr-line">
              <div class="tr-line-top"></div>
              <div class="tr-line-bottom"></div>
            </div>
            <div class="tr-time">{{ v.time }}</div>
            <div class="tr-content">{{ v.training_name }}</div>
          </li>
        </ul>
        <div v-if="trainings.length > 3" @click="handleFold">
          <p class="unfold-btn" v-if="folded">
            查看剩余{{ trainings.length - 3 }}段培训
          </p>
          <p class="unfold-btn" v-else>收起</p>
        </div>
      </template>

      <div class="bottom-tip">
        咨询师本人承诺以上资料全部属实，接受公众监督，并为此承担相应法律责任。
      </div>
    </div>
    <tagDetailPopup :tagDetail="tagDetail" @close="tagDetail = null" />
  </div>
</template>

<script>
import tagDetailPopup from './tagDetailPopup.vue'
export default {
  components: {
    tagDetailPopup
  },
  data() {
    return {
      folded: true,
      tagDetail: null
    }
  },
  computed: {
    consultServiceInfo() {
      return this.$store.getters['homepage/consultServiceInfo']
    },
    parsedQualifications() {
      const { qualifications = [] } = this.consultServiceInfo
      return qualifications.filter(item => !!item).join('，')
    },
    myCase() {
      const { case: myCase = {} } = this.consultServiceInfo
      return myCase
    },
    trainings() {
      const { trainings = [] } = this.consultServiceInfo
      return trainings
    },
    slicedTrainings() {
      return this.folded ? this.trainings.slice(0, 3) : this.trainings
    },
    basicInfo() {
      return this.$store.state.homepage.basicInfo || {}
    },
    tagList() {
      const { consult_identities } = this.basicInfo
      let arr = Array.isArray(consult_identities) ? consult_identities : []
      if (!arr || !arr.length) return ''
      arr = arr.find(i => i.title.includes('年审通过'))
      return arr
    }
  },
  methods: {
    handleFold() {
      if (this.folded) {
        this.$trackEvent('newprofilepages_training_all', {})
      }
      this.folded = !this.folded
    },
    onTagClick() {
      this.tagDetail = this.tagList
    }
  }
}
</script>

<style lang="scss" scoped>
.hp-title {
  padding-bottom: 26px !important;
  padding-top: 50px;
  align-items: center;
  &:nth-of-type(1) {
    padding-top: 0;
  }
  .ic-year {
    display: flex;
    align-items: center;
    height: 36px;
    background: url('~images/platform/homepage/ic-year.png') no-repeat;
    background-size: 100% 100%;
    color: #6c798c;
    padding: 8px 12px 8px 41px;
    margin-left: 16px;
    box-sizing: border-box;
    .ic-year-text {
      display: block;
      padding-top: 2px;
      font-size: 20px;
      box-sizing: border-box;
    }
  }
}
.desc-panel {
  .normal-text {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6c798c;
    line-height: 38px;
  }
  .bottom-tip {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9da3ac;
    line-height: 40px;
    margin-top: 50px;
  }

  .training-desc {
    font-size: 28px;
    text-align: justify;
    line-height: 48px;
    color: #566171;
    padding-left: 10px;
  }

  $pl: 28px;

  .unfold-btn {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #6982fa;
    font-weight: 500;
    padding-left: $pl + 8;
    margin-top: 20px;
    text-align: center;
  }
  .training {
    padding-bottom: 40px;
    position: relative;
    // background-color: #ccc;
    &:last-of-type {
      padding-bottom: 0;
    }
    .tr-time {
      position: relative;
      color: #9da3ac !important;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      // background-color: green;
      padding-left: $pl;
      &::before {
        content: '';
        display: inline-block;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(-7px, -50%);
        border-radius: 50%;
        width: 16px;
        height: 16px;
        background: #6982fa;
      }
    }
    .tr-content {
      color: #6c798c !important;
      line-height: 1.5 !important;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      margin-top: 4px;
      padding-left: $pl;
    }
    .tr-line {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 0;
      display: flex;
      flex-direction: column;
      opacity: 0.4;
      .tr-line-top {
        width: 100%;
        height: 28px;
        border-left: 1px dashed #6982fa !important;
      }
      .tr-line-bottom {
        width: 100%;
        height: 28px;
        flex: 1;
        border-left: 1px dashed #6982fa !important;
      }
    }
    &:first-of-type .tr-line-top {
      border-left: 1px dashed transparent !important;
    }
    &:last-of-type .tr-line-bottom {
      border-left: 1px dashed transparent !important;
    }
  }
}
</style>
